import React from "react";
import { PropTypes } from "prop-types";
import BottomNavbar from "../BottomNavbar/BottomNavbar";
import { Box } from "@mui/material";

const ContentPlayerBottomNavbar = ({ navButtons }) => {
  return (
    <BottomNavbar>
      <Box display="flex" justifyContent="flex-end" flex={1}>
        {navButtons}
      </Box>
    </BottomNavbar>
  );
};

export default ContentPlayerBottomNavbar;

ContentPlayerBottomNavbar.propTypes = {
  navButtons: PropTypes.element
};
